import { takeLatest } from 'redux-saga/effects';
import * as authTypes from './auth.types';
import {
  onGetMeRequest,
  onLogOutTry,
  onGetAuthHandler,
  onGetUniversalLoginScreen,
  onAuthResetPassword,
} from './effects';

export function* getMeRequestSaga() {
  yield takeLatest(authTypes.GETME_REQUEST, onGetMeRequest);
}

export function* logOutTrySaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(authTypes.LOG_OUT_TRY, onLogOutTry);
}

export function* getUniversalAuthOScreen() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(authTypes.AUTHO_LOGIN, onGetUniversalLoginScreen);
}

export function* getUniversalAuthUser() {
  yield takeLatest(authTypes.HANDLE_AUTHENTICATION, onGetAuthHandler);
}

export function* authResetPasswordSaga() {
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  yield takeLatest(authTypes.AUTH0_PASSWORD_RESET, onAuthResetPassword);
}
